import {
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_LOADED,
} from "../../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  authenticated: false,
  loading: true,
  user: null,
  settings: {},
};

function authReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: payload.token,
        authenticated: true,
        loading: false,
        user: payload.user,
      };
    case USER_LOADED:
      return {
        ...state,
        authenticated: true,
        user: payload,
      };
    case AUTH_ERROR:
    case LOGOUT:
      return {
        ...state,
        token: null,
        authenticated: false,
        user: null,
      };
    default:
      return state;
  }
}

export default authReducer;
